import { FilterTypesEnum } from '../FilterTypesEnum';
import { FilterModel } from './filter.model';

export class StringSmallerFilterModel extends FilterModel {
  override symbol: FilterTypesEnum = FilterTypesEnum.string_smaller;

  isValid() {
    return !!this.value;
  }
}
